module.exports = __webpack_public_path__ + "static/media/brand-loader.a6682d41.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brand-loader.gif
// module id = 2326
// module chunks = 0